import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';
import log from 'eslint-plugin-react/lib/util/log';

export const attendanceApi = createApi({
  reducerPath: 'attendanceApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    //Export
    getAttendanceExport: builder.query({
      query: (user_id) => ({
        url: urls.attendanceExport(user_id),
        responseHandler: (response) => response.blob(), // Ensure we handle the response as a Blob
      }),
    }),

    //Schedule
    getAttendanceSchedule: builder.query({
      query: (teacher_id) => ({
        url: urls.attendanceSchedule(teacher_id),
      }),
    }),

    //FoEvents
    getAttendanceEvents: builder.query({
      query: () => ({
        url: urls.attendanceEvents,
      }),
    }),
    getAttendanceEvent: builder.query({
      query: (att_event) => ({
        url: urls.attendanceEventDetail(att_event),
      }),
    }),
    getAttendanceEventByTeacher: builder.query({
      query: (teacher_id) => ({
        url: urls.attendanceEventByTeacher(teacher_id),
      }),
    }),
    getAttendanceTeacherSubjectsEvents: builder.query({
      query({ person_id, events, all }) {
        return {
          url: urls.attendanceTeacherSubjectsEvents(person_id, events, all),
          method: 'GET',
        };
      },
    }),
    saveAttendanceEvent: builder.mutation({
      query(req) {
        return {
          url: urls.attendanceEvents,
          method: 'POST',
          data: req.body,
        };
      },
    }),
    deleteAttendanceEvent: builder.mutation({
      query(id) {
        return {
          url: urls.attendanceEventsDelete(id),
          method: 'DELETE',
        };
      },
    }),

    //Attendance
    getAttendancePointDetailForEvent: builder.query({
      query: (att_event_id) => ({
        url: urls.attendanceEvent(att_event_id),
      }),
    }),
    getAttendancePointDetailForStudent: builder.query({
      query: (user_id) => ({
        url: urls.attendanceUser(user_id),
      }),
    }),
    getAttendancePointsOverview: builder.query({
      query: (teacher_id) => ({
        url: urls.attendanceUsersForEvents(teacher_id),
      }),
    }),
    saveAttendancePoints: builder.mutation({
      query(req) {
        if (req.att_event_id) {
          if (Object.hasOwn(req, 'type')) {
            if (req.type === 'user') {
              return {
                url: urls.attendancePointsToUser,
                method: 'PUT',
                data: req,
              };
            } else if (req.type === 'all-users') {
              return {
                url: urls.attendanceAddPointsToUsers,
                method: 'PUT',
                data: req,
              };
            }
          } else {
            return {
              url: urls.attendance,
              method: 'POST',
              data: req,
            };
          }
        }
      },
    }),
    deleteAttendancePoints: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.attendanceDelete(req.id),
            method: 'DELETE',
          };
        }
      },
    }),
  }),
});

export const {
  //Export
  useLazyGetAttendanceExportQuery,

  //Schedule
  useGetAttendanceScheduleQuery,

  //FoEvents
  useGetAttendanceEventsQuery,
  useGetAttendanceEventQuery,
  useGetAttendanceEventByTeacherQuery,
  useGetAttendanceTeacherSubjectsEventsQuery,
  useSaveAttendanceEventMutation,
  useDeleteAttendanceEventMutation,

  //Attendance
  useGetAttendancePointDetailForEventQuery,
  useGetAttendancePointDetailForStudentQuery,
  useGetAttendancePointsOverviewQuery,
  useSaveAttendancePointsMutation,
  useDeleteAttendancePointsMutation,
} = attendanceApi;
